import { useQuery } from '@tanstack/react-query'
import { cmApi } from '@/api/cmApi'
import { authHeaders } from '@/auth/session'
import { namesFromGetEventsForPll } from '@/api/map/plStatement'
import { keys } from '@/api/hooks/shared/keys'

export type EventsForPllQuery = {
  range: { from: string; to: string }
  game?: string
  subGame?: string
  memberIds?: string[]
  tms?: string
  name?: { _id: string; accessLevel?: string }
}

function eventsBody(query: EventsForPllQuery): Record<string, unknown> {
  const body: Record<string, unknown> = {
    fromDate: query.range.from.slice(0, 10),
    toDate: query.range.to.slice(0, 10),
  }
  if (query.game && query.game !== 'all') body.game = query.game
  if (query.subGame) body.subGame = query.subGame
  if (query.memberIds?.length) body.playerName = query.memberIds
  if (query.tms) body.tms = query.tms
  if (query.name?._id) body.name = query.name
  return body
}

async function loadEventsForPll(query: EventsForPllQuery): Promise<string[]> {
  const response = await cmApi.getEventsForPll(authHeaders(), eventsBody(query))
  return namesFromGetEventsForPll(response)
}

/** Lab `Account/getEventsForPLL` — distinct event names in the P&L window. */
export function useEventsForPll(query: EventsForPllQuery) {
  return useQuery({
    queryKey: keys.eventsForPll({
      from: query.range.from.slice(0, 10),
      to: query.range.to.slice(0, 10),
      ...(query.game ? { game: query.game } : {}),
      ...(query.subGame ? { subGame: query.subGame } : {}),
      ...(query.memberIds?.length ? { memberIds: query.memberIds } : {}),
      ...(query.tms ? { tms: query.tms } : {}),
      ...(query.name?._id ? { nameId: query.name._id } : {}),
    }),
    queryFn: () => loadEventsForPll(query),
    staleTime: 30_000,
  })
}
